import type { Card } from '../../types';

/** §14 worked card (ADR-0015 §17 mapping). Charged (trigger / atChargeMax): every
 * turn-end adds a charge; at 5 charges it detonates for 30 to each side, then
 * resets. Pressure card — outpace the self-bleed. */
export const DOOMSDAY_CLOCK: Card = {
  id: 'doomsday-clock',
  name: 'Doomsday Clock',
  type: 'trap',
  rarity: 'legendary',
  size: { w: 2, h: 2 },
  cost: [],
  effects: [
    { kind: 'damage', amount: 30, target: 'opponent' },
    { kind: 'damage', amount: 30, target: 'self' },
  ],
  trap: {
    variant: 'charged',
    trigger: { kind: 'turnEnd' },
    chargeMax: 5,
    chargeSource: 'trigger',
    fireMode: 'atChargeMax',
  },
};
